import { useState } from 'react';
import DangerIcon from '../../../assets/icons/danger.svg?react';
import { useDeleteCharger } from '../../../hooks/queries/chargerQueries';

const ChargerDeleteModal = ({onClose, charger, stationInfo, onDeleteSuccess}) => {
  // React Query mutation 훅을 컴포넌트 최상위 레벨에서 호출
  const deleteChargerMutation = useDeleteCharger();
  
  const handleDelete = async () => {
    try {
      // 여러 충전기를 삭제하는 경우
      const deletePromises = [deleteChargerMutation.mutateAsync(charger.ChargerSysId)];
      await Promise.all(deletePromises);
      onDeleteSuccess(); // 삭제 성공 시 콜백 호출
      onClose();
    } catch (error) {
      console.error('충전기 삭제 실패:', error);
      alert('충전기 삭제에 실패했습니다.');
    }
  };
  
  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header flex-col gap-10">
          <DangerIcon className='text-error'/>
          <h3>충전기를 삭제하시겠습니까?</h3>
        </div>
        <div className="modal-content">
          <table className='gray-table'>
            <tr>
              <th width="160px">충전기 고유 식별자</th>
              <td>{charger.CpoChargerId}</td>
            </tr>
            <tr>
              <th>용량(kWh)</th>
              <td>{charger.ChargerCapacity}</td>
            </tr>
            <tr>
              <th>충전소 식별자</th>
              <td>{charger.CpoStationId}</td>
            </tr>
            <tr>
              <th>충전소 이름</th>
              <td>{stationInfo?.CpoStationName}</td>
            </tr>
          </table>
        </div>
        <div className="modal-footer">
          <button className="btn py-5 px-10 btn-style-5" onClick={onClose}>취소</button>
          <button 
            className="btn py-5 px-10 btn-primary" 
            onClick={handleDelete}
            disabled={deleteChargerMutation.isPending}
          >
            {deleteChargerMutation.isPending ? '삭제 중...' : '삭제하기'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ChargerDeleteModal